module.exports = __webpack_public_path__ + "static/media/ott.d0462fa6.png";